export default __webpack_public_path__ + "static/media/1332.90aecc18.png";